import { HeaderMenu, Loading } from "components";
import { Fragment, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FormAction } from "../FormAction";
import { FormSection } from "../FormSection";
import { convertNumber, today } from "utils";
import { useDetailOpeningStock } from "../../utils";
import { FormType } from "../../utils/vars";

export type FormSectionProps = {
    opening_stock_id: number,
    isEdit?: boolean
}

export type DefaultValues = Pick<FormType, 'transaction_date' | 'location_id' | 'product_id' | 'mr_unit_id' | 'av_price_unit' | 'soh'>

export function DetailOpeningStock({
    opening_stock_id,
    isEdit = false
}: FormSectionProps){

    const {data, isLoading} = useDetailOpeningStock({
        id_opening_stock: Number(opening_stock_id)
    })

    const defaultValues: DefaultValues = {
        transaction_date: today(),
        location_id: '',
        product_id:  '',
        mr_unit_id:  '',
        av_price_unit: '',
        soh: ''
    }

    const methods = useForm<DefaultValues>({
        defaultValues: defaultValues
    })

    useEffect(() => {
        if (data[0]) {
            methods.setValue('location_id', data[0].location_id)
            methods.setValue('product_id', data[0].product_id)
            methods.setValue('mr_unit_id', data[0].unit_name)
            methods.setValue('transaction_date', data[0].transaction_date)
            methods.setValue('av_price_unit', data[0]?.av_price_unit ?? '')
            methods.setValue('soh', Number(data[0].soh) % 1 === 0 ? convertNumber(Number(data[0].soh)).intoNormalAmount : data[0].soh.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, ''))
        }
        // eslint-disable-next-line
    }, [data[0]])



    return (
        <Fragment>
            <section className="container my-5">
                <section>
                    <HeaderMenu title="DATA ENTRY | OPENING STOCK" />
                    <section className="mt-2">
                        <section className="mt-2">
                            <FormProvider {...methods}>
                                <FormAction
                                    isEdit={isEdit}
                                >
                                    {isLoading ? (
                                        <Loading
                                            loading={isLoading}
                                            errorText={isLoading ? "" : "No data available"}
                                        />
                                    ) : (
                                        <FormSection openingStockDetail={data[0]} />
                                    )}
                                </FormAction>
                            </FormProvider>
                        </section>
                    </section>
                </section>
            </section>
        </Fragment>
    )
}